module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightlightrain@2-31ac05645fbeea7d3ca39b22e5588187.png";